import * as Yup from 'yup'

export const LogInSchema = Yup.object().shape({
  email: Yup.string()
    .email('Por favor informar um e-mail válido.')
    .required('O email é obrigatório.'),
  password: Yup.string().required('A senha é um campo obrigatório'),
})
